'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _footer = require('./footer.html');

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Footer = function () {
    function Footer() {
        _classCallCheck(this, Footer);

        this.template = _footer2.default;
        this.restrict = 'E';
    }

    /**
     * Factory
     * @return {Object}
     */


    _createClass(Footer, null, [{
        key: 'directiveFactory',
        value: function directiveFactory() {
            Footer.instance = new Footer();
            return Footer.instance;
        }
    }]);

    return Footer;
}();

exports.default = Footer;


/** WEBPACK FOOTER **
 ** ./src/app/directives/footer/footer.js
 **/